import React from "react";

import { AnyEntity, Company, Deal, EntityType, Person } from "@mapmycustomers/shared/types/entity";

import CompanyInfoWindow from "./infoWindows/CompanyInfoWindow";
import DealInfoWindow from "./infoWindows/DealInfoWindow";
import PersonInfoWindow from "./infoWindows/PersonInfoWindow";

const defaultSelectedEntityNodeGetter = <T extends AnyEntity>(
  entity: T,
  entityType: EntityType,
  callbackName?: string,
  companyClickCallbackName?: string,
  personClickCallbackName?: string
): React.ReactNode => {
  switch (entityType) {
    case EntityType.COMPANY:
      return <CompanyInfoWindow callbackName={callbackName} company={entity as Company} />;
    case EntityType.DEAL:
      return (
        <DealInfoWindow
          callbackName={callbackName}
          companyClickCallbackName={companyClickCallbackName}
          deal={entity as Deal}
          personClickCallbackName={personClickCallbackName}
        />
      );
    case EntityType.PERSON:
      return <PersonInfoWindow callbackName={callbackName} person={entity as Person} />;
    default:
      return null;
  }
};

export default defaultSelectedEntityNodeGetter;
